import { RecommendationDisplayMode } from 'data/Product';

export const DISPLAY_MODE: Record<RecommendationDisplayMode, RecommendationDisplayMode> = {
  ORDERED: 'ORDERED',
  RANDOM: 'RANDOM',
};

// Picker search runs once the vendor has typed more than 3 characters; mirrors the API.
export const RECOMMENDATION_SEARCH_MIN_LENGTH = 4;
export const RECOMMENDATION_SEARCH_DEBOUNCE_MS = 300;

export const DISPLAY_MODE_LABELS: Record<RecommendationDisplayMode, string> = {
  ORDERED: 'In entered order',
  RANDOM: 'Randomly',
};

export const RECOMMENDATION_STRINGS = {
  SECTION_HEADING: 'Product Recommendations & Promotions',
  SECTION_TOOLTIP:
    'Create one or more custom sections to recommend related products for this product.',
  ADD_SECTION: 'Add recommendation section',
  EMPTY_TITLE: 'No recommendation sections added yet',
  EMPTY_SUBTITLE: 'Create one or more custom sections to recommend related products.',
  CARD_LABEL: 'Recommendation section',
  EDIT: 'Edit',
  REMOVE: 'Remove',
  SAVE_NEW: 'Save recommendation section',
  SAVE_EDIT: 'Save changes',
  CANCEL: 'Cancel',
  SECTION_TITLE_LABEL: 'Section title',
  SECTION_TITLE_PLACEHOLDER: 'Select a title',
  DISPLAY_MODE_LABEL: 'Display mode',
  MANUAL_ADD_LABEL: 'Manual add',
  MANUAL_ADD_PLACEHOLDER: 'Search and select products',
  SEARCH_HINT: `Type at least ${RECOMMENDATION_SEARCH_MIN_LENGTH} characters to search`,
  SEARCHING: 'Searching…',
  NO_PRODUCTS_FOUND: 'No matching products found.',
  SEARCH_FAILED: 'Products could not be loaded. Please try again.',
  TITLES_FAILED: 'Recommendation titles could not be loaded.',
  COL_PRODUCT_NAME: 'Product name',
  COL_SKU: 'SKU',
  COL_ACTIONS: 'Actions',
  NO_PRODUCTS_ADDED: 'No products added yet',
  PRODUCTS_ADDED: (count: number) => `${count} product${count === 1 ? '' : 's'} added`,
  PRODUCT_COUNT: (count: number) => `${count} product${count === 1 ? '' : 's'}`,
  PRODUCTS_SELECTED: (count: number) => `${count} product${count === 1 ? '' : 's'} selected`,
  REMOVE_CONFIRM_TITLE: 'Remove recommendation section',
  REMOVE_CONFIRM_MESSAGE:
    'Are you sure you want to remove this recommendation section? All products added to this section will be removed.',
  REMOVE_PRODUCT: 'Remove product',
  // Accessible name of a row's delete icon; distinct from the dialog's "Remove product" button.
  REMOVE_PRODUCT_ROW_LABEL: (name: string) => `Remove ${name}`,
  REMOVE_PRODUCT_CONFIRM_MESSAGE: 'Are you sure you want to remove this product from the recommendation section?',
  EDITOR_OPEN_TOOLTIP: 'Save or cancel the open recommendation section first.',
} as const;

export const RECOMMENDATION_ERRORS = {
  TITLE_REQUIRED: 'Section title is required.',
  DUPLICATE_TITLE: 'This section title has already been added. Please select a different title.',
  PRODUCTS_REQUIRED: 'Add at least one product to the recommendation section.',
} as const;
